export const ru = {
    'button-cancel': 'Отмена',
    'button-submit': 'Применить',
    'highest-bid': 'Обратите внимание — остановлена слишком высокая ставка',
    'validation-error-not-a-number': 'Введите число'
};
